import { fetchWithAuth } from "../utils/apiUtils";

export default class LoginService {
    private static loginPath = 'auth';

    constructor() { }

    public static async login(email: string, password: string, otp?: string) {
        const headers: Record<string, string> = {
            "Content-Type": "application/json",
        };
        
        if (otp) {
            headers["x-otp"] = otp;
        }
        
        return await fetchWithAuth(`${this.loginPath}/login`, {
            method: "POST",
            headers,
            body: JSON.stringify({
                email,
                password,
                ...(otp && { otp })
            })
        })
    }

    public static async requestPasswordReset(email: string) {
        return await fetchWithAuth(`${this.loginPath}/request-reset`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email })
        });
    }

    public static async resetPassword(token: string, password: string) {
        return fetchWithAuth(`${this.loginPath}/reset-password`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token, password })
        })
    }

    public static async organizationSignup(organizationData: {
        organizationName: string;
        organizationPhoneNumber: string;
        organizationEmail: string;
        organizationAddress?: {
            street: string;
            city: string;
            state: string;
            zipCode: string;
        };
        firstName: string;
        lastName: string;
        phoneNumber: string;
        email: string;
        password: string;
        userType: string;
    }) {
        const response = await fetchWithAuth(`${this.loginPath}/organization-signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(organizationData)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    }
}